import {
  CustomerCard,
  Gtm,
  Product as GtmProduct,
  Service as GtmService,
  ReviewPaymentDataLayer as ReviewPaymentGtm,
} from '../../requests/caipirinha-api/interfaces/gtm.interface';
import {
  Payment,
  Product as OrderProduct,
  Service as OrderService,
} from '../../requests/caipirinha-api/interfaces/order.interface';
import { isMobile } from '../../utils/screen.util';
import { removeAccents } from '../../utils/text.util';

export const useGtm = () => {
  const getCityState = (city: string, state: string): string | undefined => {
    const cityState = `${city}:${state}`;
    return removeAccents(cityState.replace(' ', '-').toLocaleLowerCase());
  };

  const getCookieValue = (name = '_ga'): string | undefined => {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match.pop() : '';
  };

  const getCustomerCard = (payments?: Payment[]): CustomerCard => {
    if (!payments) return undefined;
    return payments
      .map(p => p.description.toLocaleLowerCase())
      .indexOf('magalucard') !== -1
      ? 'verdadeiro'
      : 'falso';
  };

  const getDevice = (): string => (isMobile() ? 'site-mobile' : 'desktop');

  const getHitTimestamp = (): string => Date.now().toString();

  const getPaymentTypes = (payments?: Payment[]): string | undefined => {
    if (!payments) return undefined;
    return payments
      .map(payment => {
        const description = payment.description
          .replace(' ', '-')
          .toLocaleLowerCase();
        return removeAccents(description);
      })
      .join('+');
  };

  const getProducts = (products?: OrderProduct[]): GtmProduct[] => {
    if (!products) return [];
    return products.map(product => ({
      id: product.id,
      name: product.description,
      price: product.value.toFixed(2),
      quantity: product.quantity.toString(),
    }));
  };

  const getRevenue = (amount: number, shipping?: number): string => {
    let revenue = amount;
    if (shipping) revenue = amount - shipping;
    return revenue.toFixed(2);
  };

  const getServices = (services?: OrderService[]): GtmService[] => {
    if (!services) return [];
    return services.map(service => ({
      id: service.id,
      name: service.description,
      brand: 'servicos',
      price: service.value.toFixed(2),
      quantity: '1',
    }));
  };

  const setDataLayer = (dataLayer: Gtm | ReviewPaymentGtm) => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push(dataLayer);
  };

  return {
    getCityState,
    getCookieValue,
    getCustomerCard,
    getDevice,
    getHitTimestamp,
    getPaymentTypes,
    getProducts,
    getRevenue,
    getServices,
    setDataLayer,
  };
};
